import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { size } from 'lodash';
import { FORM_MODES } from 'config/formModes';
import { useFetchedCampaign } from 'modules/campaigns/hooks/useFetchedCampaign';
import { selectedRowsSelector } from 'modules/campaigns/selectors';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';

export const useCreativeCampaignData = () => {
    const { data, mode } = useFormDataContext();
    const selectedRows = useSelector(selectedRowsSelector);
    const { campaigns } = data;

    const selectedCampaignId = useMemo(() => {
        if (mode === FORM_MODES.CREATE) {
            return campaigns?.[0]?.id;
        }
        if (mode === FORM_MODES.BULK_DUPLICATE) {
            const firstKey = Object.keys(selectedRows)[0];
            return selectedRows[firstKey]?.campaignId;
        }
        return data?.campaignId;
    }, [mode, data?.campaignId, campaigns, selectedRows]);
    const { campaign: fetchedCampaign } = useFetchedCampaign(selectedCampaignId);
    const isSingleCampaignSelected =
        mode !== FORM_MODES.BULK_DUPLICATE ? campaigns?.length === 1 : size(selectedRows) === 1;
    return { fetchedCampaign, isSingleCampaignSelected };
};
